export default "__VITE_ASSET__BMp_u$p$__"